import { HttpClient, HttpParams } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';

export interface RealmRole {
  id: string,
  name: string,
  description: string
}
export interface UserRealmRoles {
  realmRoles: RealmRole[] 
}
@Injectable({
  providedIn: 'root'
})
export class UsersService {

  private readonly http = inject(HttpClient);

  addNewUser(params:any){
    return this.http.post(`${environment.api.host_path}/users`, params);
  }

  editUser(params: any) {
    return this.http.put(`${environment.api.host_path}/users`, params);
  }

  getUsersList(offset: number, limit: number, sort: string, direction: string, filter?: { email?: string }): Observable<any> {
   let params = new HttpParams()
      .set('limit', limit.toString())
      .set('offset', offset.toString())
      .set('sort', sort)
      .set('direction', direction);

    if(filter) {
      if(filter.email) {
        params = params.set('email', filter.email);
      }
    }
    return this.http.get<any>(`${environment.api.host_path}/users/list`, { params });
  }

  deleteUser(keycloakId: number){
    return this.http.delete(`${environment.api.host_path}/users/${keycloakId}`);
  }

  getLoggedUserInfo(keycloakId: string){
    return this.http.get(`${environment.api.host_path}/users/${keycloakId}`);
  }

  getRolesList(){
    return this.http.get(`${environment.api.host_path}/users/roles`);
  }

  getUserRole(keycloakId: string): Observable<UserRealmRoles> {
    return this.http.get<UserRealmRoles>(`${environment.api.host_path}/users/${keycloakId}/roles`);
  }

  changePassword(params: any){
    return this.http.put(`${environment.api.host_path}/users/me/password`, params);
  }
}
